import React from "react";
import { ToggleButton } from "@mui/lab";
import styled from "styled-components";

const StyledToggleButton = styled(ToggleButton)`
    font-size: 12px;
    text-transform: none;
    font-weight: 300;
    width: 150px;
`;

const ButtonContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: -6px;
    & > * {
        margin: 6px;
    }
`;

const MissionCategoryToggle = ({ selectedCategory, setSelectedCategory }) => {
    const handleChange = (event, newCategory) => {
        if (newCategory !== null) {
            setSelectedCategory(newCategory);
        }
    };

    return (
        <ButtonContainer>
            <StyledToggleButton
                value="work"
                selected={selectedCategory === "work"}
                onClick={() => handleChange(null, "work")}
            >
                Work
            </StyledToggleButton>
            <StyledToggleButton
                value="collaboration"
                selected={selectedCategory === "collaboration"}
                onClick={() => handleChange(null, "collaboration")}
            >
                Collaboration
            </StyledToggleButton>
            <StyledToggleButton
                value="wellbeing"
                selected={selectedCategory === "wellbeing"}
                onClick={() => handleChange(null, "wellbeing")}
            >
                Wellbeing
            </StyledToggleButton>
        </ButtonContainer>
    );
};

export default MissionCategoryToggle;
